@if (color) {
  <div class="inner-column no-select" [ngClass]="{'precious': brandModeService.isPrecious, 'extra-padding': !variantOrModelIsNew}" (click)="onClicked()">
    <div class="color-image">
      <img [src]="imageService.GetColorImageUrl($safeNavigationMigration(color.Color?.ColorLine?.Code), $safeNavigationMigration(color.Color?.Code))"/>
      @if (extendedInformation && color.Color?.Description2?.Fallback) {
        <i [ngClass]="[showDetailId === color.Id ? 'icon-info-clicked' : 'icon-info-notclicked', 'fa-light fa-info-circle information-icon']" (click)="showDetails(color.Id);$event.stopPropagation()"></i>
      }
    </div>
    @if (color.Color?.Description?.Fallback !== color.Color?.Code && (brandModeService.isTitanium || color.Color?.ColorLine?.Code === 'HORN')) {
      <div class="description">
        <h6 [innerHTML]="color.Color?.Code || ''"></h6>
      </div>
    }
    <div class="descriptions">
      <h6 [innerHTML]="color.Color?.Description || '' | dataTranslate | translate"></h6>
      @if (!useColorGroup && color.Color?.ColorGroup && !extendedInformation) {
        <h6 [innerHTML]="color.Color?.ColorGroup?.Description || '' | dataTranslate | translate"></h6>
      }
    </div>
    @if (!extendedInformation && color.Color?.Description2 &&( color.Color?.Description2 || '' | dataTranslate | translate).length > 0) {
      <div class="name">
        <h6 [innerHTML]="color.Color?.Description2 || '' | dataTranslate | translate"></h6>
      </div>
    }
    @if (extendedInformation && showDetailId === color.Id) {
      <div class="description text">
        <p (click)="$event.stopPropagation()" [innerHTML]="(color.Color?.Description2 || '' | dataTranslate | translate)"></p>
        @if (extendedInformation && extendedInformationTable) {
          <button class="btn-secondary" (click)="showSunDetails($event)">{{ 'CUSTOMISER.VIEW-SUN-DETAILS' | translate }}</button>
        }
      </div>
    }
    @if (color.Color?.ColorType && specialColorText) {
      <div class="specialDescription">
        <p [innerHTML]="specialColorText | translate"></p>
      </div>
    }
    @if (variantOrModelIsNew ) {
      <div class="name availablility">
        <h6>
          <availability-text [variantOrModelIsNew]="variantOrModelIsNew" [date]="color.Discontinued" [new]="color.New" [useNewDetails]="false"></availability-text>
        </h6>
      </div>
    }
  </div>
}

@if (!color && showNoneChoiceOption) {
  <div class="no-color" (click)="onClicked()">
    {{noneChoiceTranslation | translate}}
  </div>
}

@if (selected && showOverlay) {
  <menu-overlay [mainOverlayText]="mainOverlayText" [secondOverlayText]="secondOverlayText" (overlayClicked)="onColorMatchClicked()"></menu-overlay>
}